module.exports = __webpack_public_path__ + "static/media/logo.5da70e09.png";